import { useCallback } from "react";
import { reportUnusableQuestionnairePayload } from "web_myplann/Api/Nsure/openQuestionnaire";
import {
	TimelineItemCategoryEnum,
	type TimelineItemResponseDTO,
	TimelineItemSubcategoryEnum,
} from "web_myplann/Infrastructure/Api/Api";
import {
	type UsePerformTimelineNavigationOptions,
	usePerformTimelineNavigation,
} from "web_myplann/NotificationCenter/Hooks/usePerformTimelineNavigation";
import { getZzjBridgeUrl } from "web_myplann/NotificationCenter/Utils/getZzjBridgeUrl";
import { parseClientActionData } from "web_myplann/NotificationCenter/Utils/parseClientActionData";
import { resolveTimelineNavigation } from "web_myplann/NotificationCenter/Utils/resolveTimelineNavigation";
import { device, NavigationTypes } from "web_myplann/Utils/device";

export type UseNavigateFromResolvingNowItemOptions =
	UsePerformTimelineNavigationOptions;

export const useNavigateFromResolvingNowItem = (
	options?: UseNavigateFromResolvingNowItemOptions,
): ((item: TimelineItemResponseDTO) => void) => {
	const performNavigation = usePerformTimelineNavigation(options);

	return useCallback(
		(item: TimelineItemResponseDTO) => {
			const navigation = resolveTimelineNavigation(item);
			if (navigation) {
				performNavigation(navigation);
				return;
			}

			// Položka „právě řešíte“ je klikací vždy (ResolvingNowItem nezná
			// navigovatelnost). Rozpracovaný dotazník bez použitelného payloadu je
			// stejná vada jako rozbitý push — hlásíme ji stejně, místo tichého no-op.
			if (
				item.subcategory ===
				TimelineItemSubcategoryEnum.ClientActionInvestmentQuestionnaire
			) {
				reportUnusableQuestionnairePayload(`timeline item ${item.id}`);
				return;
			}

			if (item.category === TimelineItemCategoryEnum.ClientAction) {
				const clientActionData = parseClientActionData(item.data);
				const bridgeUrl = clientActionData
					? getZzjBridgeUrl(clientActionData)
					: null;
				if (bridgeUrl) {
					device.navigationRequest(NavigationTypes.ZZJ, bridgeUrl);
				}
			}
		},
		[performNavigation],
	);
};
